import { styled } from '@linaria/react';
import { Flex, Transition } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { ReactNode } from 'react';
import { secondaryBase } from '../../styles/design-tokens';
import { Icon } from '../../ui-library/icon/icon';
import { Text } from '../../ui-library/typography/typography';
import { CommonContainer } from './page-layout.styles';

type Props = {
  title?: string;
  content: ReactNode;
  show?: boolean;
  setShow?: (show: boolean) => void;
  width?: number;
};

export const SideFilters = ({ title = 'Filters', content, show, setShow, width = 286 }: Props) => {
  const [internalOpened, { toggle: internalToggle }] = useDisclosure(true);

  // Use external state if provided, otherwise use internal state
  const opened = show !== undefined ? show : internalOpened;

  // Handle toggle based on whether external control is provided
  const handleToggle = () => {
    if (setShow !== undefined) {
      setShow(!opened);
    } else {
      internalToggle();
    }
  };

  return (
    <Container>
      {!opened && (
        <ExpandButton onClick={handleToggle}>
          <Flex align="center" gap={12} style={{ transform: 'rotate(270deg)' }}>
            <Icon name="filter_list" size={18} color={secondaryBase} style={{ cursor: 'pointer' }} />
            <Text size="small" weight="bold" color={secondaryBase}>
              {title}
            </Text>
          </Flex>
        </ExpandButton>
      )}
      <Transition mounted={opened} transition="slide-right" duration={400} timingFunction="ease">
        {(styles) => <CommonContainer style={{ width, ...styles }}>{content}</CommonContainer>}
      </Transition>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

const ExpandButton = styled.div`
  width: 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--base-white);
  cursor: pointer;
  height: 100%;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: border-color 0.2s ease;
  &:hover {
    border-color: var(--secondary-base);
  }
`;
